<template>
    <div>
        <div class="left-toolbar mb10">
            <button @click="exportPdf" class="swb-btn-small swb-btn">导出pdf</button>
        </div>
        <swb-servc-work-voucher-for-export :voucherId="voucherId" ref="swb_servc_work_voucher_for_export"></swb-servc-work-voucher-for-export>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { showHtmlToPdfDlg } from '../ctrl/dialog'
    //
    import servcDelivApi from '../../api/servcDeliv'
    //
    import SwbServcWorkVoucherDetailerForExport from './ServcWorkVoucherDetailerForExport'
    Vue.regist(SwbServcWorkVoucherDetailerForExport);

    export default {
        name: 'swb-servc-work-voucher-export',
        desc: '工单导出',
        props: {
            voucherId: {
                type: Number,
                deafult: null,
            },
            no: {
                type: String,
                deafult: null,
            },
            servcType: {
                type: String,
                deafult: null,
            },
        },
        data: function () {
            return {}
        },
        created: function () {
//            this.viewProof();
        },
        methods: {
            viewProof(){
                let theDownloadUrl = Utils.makeUrl(getAppUrl('/api/devc/maint/proof/preview'), {
                    id: 7,
                });
                Utils.setPageUrl(theDownloadUrl);
            },
            exportPdf: function () {
                let self = this;
                let title = "凭单下载";
                if(self.servcType != null) {
                    if(self.servcType == 0 || self.servcType == -1) {
                        title = "维修凭单";
                    } else if(self.servcType == 1) {
                        title = "保养凭单";
                    } else if(self.servcType == 2) {
                        title = "安装凭单";
                    } else if(self.servcType == 6) {
                        title = "检验凭单";
                    }
                }
                title = title + "-" + self.no;
                let result = self.$refs.swb_servc_work_voucher_for_export.getHtml() || '';
                showHtmlToPdfDlg(title, result, null);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkVoucherExportPdf.vue